<template>
  <a-modal
      class="location-picker-2__modal"
      title="选择位置"
      :visible="visible"
      @cancel="handleCancelParent"
      @ok="handleOk"
    :width="832"
    >
    <a-row class="modal-body" :gutter="20">
      <a-col :span="10">
        <a-row :gutter="[0, 16]">
          <a-col :span="24">
            <a-auto-complete
              :allowClear="true"
              v-model="inputValue"
              style="width: 100%"
              placeholder="输入省市区地点等，越详细越准确"
              @search="handleSearch"
              option-label-prop="addressName"
              @select="handleSelect"
              @change="handleChange"
              >
              <template slot="dataSource">
                <a-select-option
                  v-for="(addressItem, index) in autoCompleteList"
                  :key="index"
                  :addressName="addressItem.name"
                  :item="addressItem"
                  :value="'[[key]]' + index"
                >
                  <div>{{ addressItem.name }}</div>
                  <div class="address-list__address">{{addressItem | addressFormatter}}</div>
                </a-select-option>
              </template>
            </a-auto-complete>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <div class="list-wrapper">
              <a-list item-layout="horizontal" :data-source="listData">
                <a-list-item
                  slot="renderItem"
                  slot-scope="item, index"
                  @click="handleClickListItem(item, index)"
                  class="address-item"
                  :class="[listSelected === index ? 'selected' : '']"
                >
                  <a-list-item-meta
                    :description="item.address"
                    :title="item.name"
                  >
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="14">
        <div class="location-piacker__map" :id="locationPickerMapId">
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
/* global AMap */
import axios from 'axios';
import config from '@/config/index';

const debounce = (func, wait) => {
  let timeout;

  // eslint-disable-next-line func-names
  return function (...args) {
    const context = this;

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};

export default {
  props: {
    visible: Boolean,
    longitude: Number,
    latitude: Number,
  },
  data() {
    return {
      locationPickerMapId: `locationPickerMap${new Date().getTime()}`,
      map: {},
      marker: {},
      listData: [],
      listSelected: -1,
      autoCompleteList: [],
      currentMarker: {
        lng: 116.397428,
        lat: 39.90923,
      },
      inputValue: '',
    };
  },
  methods: {
    // 地图初始化函数
    initMap() {
      this.map = new AMap.Map(this.locationPickerMapId);
      console.log('初始化地图');
      // 绑定事件
      this.map.on('click', this.handleMapClick);

      if (this.longitude && this.latitude) {
        // 传入参数作为中心
        this.currentMarker.lng = this.longitude;
        this.currentMarker.lat = this.latitude;
      } else {
        // 设置历史中心点
        const historyCenterStr = localStorage.getItem('locationPickerCenter');
        if (historyCenterStr) {
          const historyCenter = JSON.parse(historyCenterStr);
          this.currentMarker.lng = historyCenter.longitude;
          this.currentMarker.lat = historyCenter.latitude;
        }
      }

      // 添加标记并加载标记附近地点
      this.addMarker();
      this.fetchArroundPlace();
    },
    handleCancelParent() {
      this.$emit('update:visible', false);
      Object.assign(this.$data, this.$options.data());
    },
    handleOk() {
      const result = {
        name: '',
        address: '',
        longitude: this.currentMarker.lng,
        latitude: this.currentMarker.lat,
      };
      if (this.listSelected === -1) {
        console.log('this.listData==', this.listData);
        const firstItem = this.listData[0];
        if (this.inputValue) {
          result.name = this.getTextValue();
        } else {
          result.name = firstItem.name;
        }
        result.address = firstItem.address;
      } else {
        const selected = this.listData[this.listSelected];
        result.name = selected.name;
        result.address = selected.address;
      }
      console.log('选择了：', result);
      this.$emit('confirm', result, true);

      // 记住上次选择的位置，作为下次默认位置
      localStorage.setItem('locationPickerCenter', JSON.stringify(result));

      this.handleCancelParent();
    },
    handleSearch: debounce(async function handleSearch(value) {
      let result;
      if (!value) {
        result = [];
      } else {
        const res = await axios.post(`${config.mapServerBaseURL}/location/suggestion`, null, {
          params: {
            query: value,
            longitude: this.currentMarker.lng,
            latitude: this.currentMarker.lat,
          },
        });
        // 第二次请求也超额则直接提示
        if (!res.data.locations) {
          this.$message.error('搜索时错误了');
          this.autoCompleteList = [];
          return;
        }
        result = res.data.locations;
        result.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.key = item.address + item.name;
        });
      }
      this.autoCompleteList = result;

      // 输入自动提示时不实时显示周围数据，避免不必要的接口调用
      // await this.$nextTick();
      // this.fetchArroundPlace();
    }, 400),
    handleChange(value) {
      console.log('change==', value);
    },
    async requestRoundPlaceList(longitude, latitude) {
      const res = await axios.post(`${config.mapServerBaseURL}/location/nearby-search`, null, {
        params: {
          longitude,
          latitude,
          query: this.getTextValue(),
        },
      });

      // 第二次请求也超额则直接提示
      if (!res.data.locations) {
        this.$message.error('获取地点列表时错误了');
      }
      return res.data.locations;
    },
    async fetchArroundPlace() {
      const res = await this.requestRoundPlaceList(this.currentMarker.lng, this.currentMarker.lat);
      this.listData = res;
    },
    async handleSelect(value, options) {
      this.inputValue = '';
      const selected = options.data.attrs.item;
      const res = await this.requestRoundPlaceList(selected.longitude, selected.latitude);
      this.listData = res;

      // 右侧地图添加标记
      this.currentMarker = this.getLocationObj(selected.longitude, selected.latitude);
      this.addMarker();
    },
    async handleMapClick(event) {
      // 获取标记信息并标点
      // const res = await axios.get('https://restapi.amap.com/v3/geocode/regeo', {
      //   params: {
      //     key: config.amap.webserviceKey,
      //     location: `${event.lnglat.getLng()},${event.lnglat.getLat()}`,
      //   },
      // });

      // 添加标记
      this.currentMarker = {
        lng: event.lnglat.getLng(),
        lat: event.lnglat.getLat(),
      };

      this.addMarker();


      // 刷新左侧列表
      const res = await this.requestRoundPlaceList(this.currentMarker.lng, this.currentMarker.lat);
      this.listData = res;
    },
    addMarker() {
      if (this.marker.setMap) {
        this.marker.setMap(null);
      }
      this.marker = new AMap.Marker({
        icon: new AMap.Icon({
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
          size: new AMap.Size(26, 34), // 图标大小
          imageSize: new AMap.Size(26, 34),
        }),
        position: [this.currentMarker.lng, this.currentMarker.lat],
        offset: new AMap.Pixel(-13, -30),
      });
      this.marker.setMap(this.map);
      // 传入经纬度，设置地图中心点
      const position = new AMap.LngLat(this.currentMarker.lng, this.currentMarker.lat);
      // this.map.setCenter(position);
      this.map.setZoomAndCenter(14, position);
    },
    getLocationObj(longitude, latitude) {
      return {
        lng: longitude,
        lat: latitude,
      };
    },
    handleClickListItem(item, index) {
      this.currentMarker = this.getLocationObj(item.longitude, item.latitude);
      this.addMarker();

      // 高亮当前选择
      this.listSelected = index;
    },
    getTextValue() {
      let textValue = this.inputValue ? this.inputValue : '';
      if (textValue.startsWith('[[key]]')) {
        const index = textValue.split('[[key]]')[1];
        textValue = this.autoCompleteList[index].name;
      }
      return textValue;
    },
  },
  filters: {
    addressFormatter(addressItem) {
      const address = addressItem.address && addressItem.address.length ? addressItem.address : '';
      return address;
    },
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        await this.$nextTick;
        this.initMap();
      }
    },
    listData() {
      // 取消选择
      this.listSelected = -1;
    },
  },
  mounted() {
  },
};
</script>

<style>
.location-piacker__map {
  height: 400px;
  cursor: crosshair !important;
}
</style>

<style scoped>
.address-item {
  cursor: pointer;
  padding: 12px;
}

.address-item.selected {
  background-color: #e6f7ff;
}

.list-wrapper {
  height: 358px;
  overflow: auto;
}

.address-list__address {
  color: #00000073;
}
</style>
